import { post } from '@/utils/request'

/**
 * 多麦的订单立即结算
 * @param {string} id 订单id
 */
export default function taoke_duomai_order_settle(id) {
  return post('taoke_duomai_order_settle', { id })
}